import types from "../actions/types";

const defaultState = {
  dataCategoriesTerm: [],
};

export default (state = defaultState, action: any) => {
  switch (action.type) {
    case types.GET_CATEGORY_TERM:
      return {
        ...state,
        dataCategoriesTerm: action.dataCategoriesTerm,
      };
    default:
      return state;
  }
};
